export const VIEW_IDS = {
  repository: 'repository',
  assignedToMe: 'assigned',
  pullsAssignedToMe: 'pullsAssignedToMe',
  mentioned: 'mentioned',
  created: 'created',
  recent: 'recent',
  new: 'new',
  empty: 'empty',
}
